import fetchAPI from '../fetchAPI';

export const callStartPerformanceReport = async (payload: {
  id: string;
  billingAccountId: string;
  locationId: string;
  startDate: string;
  endDate: string;
  companyName: string;
  allocatedToken: string;
  consumeToken: string;
  availableToken: string;
  cost: string;
  title?: string;
  description?: string;
  isRefetch?: boolean;
  syncContactsFirst?: boolean;
  password?: string;
  reportVariant?: 'auto' | 'standard' | 'ooh' | 'lettings' | 'sales';
  aiPersona?: string;
}): Promise<iResponse<{ jobId: string; status: string }>> => {
  const response = await fetchAPI<{ jobId: string; status: string }>({
    method: 'POST',
    route: 'artifacts',
    data: { ...payload, kind: 'performance' }
  });
  return response;
};

export default callStartPerformanceReport;
